module.exports.profile = {
  vi: {
    title: 'Avalon: The Resistance | Hồ sơ và cài đặt',
    description: 'Hồ sơ và cài đặt tài khoản chơi The Resistance: Avalon.',
    keywords: ['Hồ sơ', 'Cài đặt', 'Tài khoản'],
  },
  pt: {
    title: 'Avalon: The Resistance | Perfil e Configurações',
    description: "Perfil e configurações para o perfil do jogo em 'Avalon: The Resistance'",
    keywords: ['Perfil', 'Configurações', 'Conta'],
  },
  en: {
    title: 'Avalon: The Resistance | Profile and Settings',
    description: "Profile and settings for game profile on 'Avalon: The Resistance'",
    keywords: ['Profile', 'Settings', 'Account'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Профиль и Настройки',
    description: "Профиль и настройки игрока в настольной игре 'Авалон: Сопротивление'",
    keywords: ['Профиль', 'Настройки', 'Аккаунт'],
  },
  es: {
    title: 'Avalon: La Resistencia | Perfil y Configuración',
    description: "Perfil y configuración del jugador en el juego de mesa 'Avalon: La Resistencia'",
    keywords: ['Perfil', 'Configuración', 'Cuenta'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 個人資料與設定',
    description: '桌遊《阿瓦隆：反抗勢力》的玩家個人資料與設定',
    keywords: ['個人資料', '設定', '帳戶'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 个人资料与设置',
    description: '桌游《阿瓦隆：反抗组织》的玩家个人资料与设置',
    keywords: ['个人资料', '设置', '账户'],
  },
};
